export default __webpack_public_path__ + "static/media/Shushing face.a7fb70bb.svg";